var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractiveIconSmaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.214,
    height: 26,
    viewBox: "0 0 28.214 41.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M8.069,74.782V61.618A3.535,3.535,0,0,1,11.044,57.9a3.479,3.479,0,0,1,4.078,3.161c.08,1.955.029,3.915.036,5.871v.685a3.275,3.275,0,0,1,2.916.682,1.563,1.563,0,0,0,1.668.414,3.343,3.343,0,0,1,3.63,1.724c.086.155.162.316.214.418a12,12,0,0,1,1.58.012,3.439,3.439,0,0,1,2.992,3.356c.027,2.155.122,4.318-.024,6.465-.287,4.27-2.549,7.249-6.31,9.216-2.633,1.378-9.482,1.437-12.211-.162A12.364,12.364,0,0,1,5.4,85.973Q3,82.368.6,78.758a3.112,3.112,0,0,1,.958-4.54,5.235,5.235,0,0,1,5.922.132C7.649,74.471,7.816,74.6,8.069,74.782Z",
    transform: "translate(-0.001 -49.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M104.272,17.88a1.421,1.421,0,0,1,1.371.782,1.194,1.194,0,0,1-.144,1.415c-1.052,1.1-2.125,2.189-3.24,3.228a1.273,1.273,0,0,1-1.761-.124,1.306,1.306,0,0,1-.106-1.806c1.02-1.085,2.083-2.129,3.16-3.161A2.173,2.173,0,0,1,104.272,17.88Z",
    transform: "translate(-85.7 -15.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M21.81,19.382a1.6,1.6,0,0,1,.842-1.188,1.179,1.179,0,0,1,1.409.128c1.09,1.033,2.164,2.089,3.186,3.189a1.278,1.278,0,0,1-.152,1.8,1.3,1.3,0,0,1-1.806.056q-1.58-1.5-3.073-3.081A3.085,3.085,0,0,1,21.81,19.382Z",
    transform: "translate(-18.677 -15.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M7.606,69.97c-.682,0-1.365.013-2.046,0A1.377,1.377,0,0,1,4.14,68.592,1.359,1.359,0,0,1,5.528,67.24q2.071-.032,4.145,0a1.322,1.322,0,0,1,1.355,1.371,1.345,1.345,0,0,1-1.375,1.355C8.97,69.984,8.286,69.97,7.606,69.97Z",
    transform: "translate(-3.545 -57.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M71.41,3.443c0-.681-.011-1.363,0-2.046A1.372,1.372,0,0,1,72.751,0a1.34,1.34,0,0,1,1.385,1.346q.039,2.1,0,4.2a1.34,1.34,0,0,1-1.385,1.349,1.367,1.367,0,0,1-1.339-1.4C71.4,4.805,71.41,4.123,71.41,3.443Z",
    transform: "translate(-61.147 0.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M113.24,69.988c-.682,0-1.365.013-2.046,0a1.363,1.363,0,0,1-1.4-1.339,1.337,1.337,0,0,1,1.345-1.385q2.1-.039,4.2,0a1.336,1.336,0,0,1,1.345,1.382,1.375,1.375,0,0,1-1.4,1.342H113.24Z",
    transform: "translate(-94.021 -57.584)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveIconSmaller);
export default __webpack_public_path__ + "static/media/interactive-icon_smaller.3cc141400f142c91d2030ea7cbb31e67.svg";
export { ForwardRef as ReactComponent };